import axios from "axios";
import { setupInterceptorsTo } from "./interceptors";

const instance = axios.create({
    baseURL: process.env.REACT_APP_URL_BACK
})

setupInterceptorsTo(instance);

export default instance;